import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-submit-dialog',
  templateUrl: 'submit-dialog.component.html',
})
export class SubmitDialogComponent {

  constructor(
    public dialogRef: MatDialogRef<SubmitDialogComponent>) { }

  onNoClick(): void {
    this.dialogRef.close();
  }

}


// WEBPACK FOOTER //
// ./src/app/shared/submit-dialog/submit-dialog.component.ts